export default __webpack_public_path__ + "static/media/reconstructive.25d2af62.png";